import * as vehicleTypes from 'commons-vehicle/Vehicle/actions/vehicleActionTypes.js';
import purchaseMethodsTypesV25 from 'commons-vehicle/PurchaseMethodsV25/actions/purchaseMethodsActionTypesV25.js';

import VehicleModelV25 from 'commons-vehicle/Vehicle/models/VehicleModelV25.js';

export default function vehicleReducer(state = new VehicleModelV25(), action) {
    switch (action.type) {
        case vehicleTypes.SET_VEHICLE:
            return action.vehicle;

        case purchaseMethodsTypesV25.LOAD_PURCHASE_METHODS_SUCCESSV25:
            return state.set('purchaseMethods', action.purchaseMethodsV25);

        default:
            return state;
    }
}
